import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { RecordEmployeeType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IRecordEditItemEmployment, RecordEditItemEmployment } from "./recordEditItemEmployment";
import { IRecordEditItemFurtherEducation, RecordEditItemFurtherEducation } from "./recordEditItemFurtherEducation";
import { IRecordEditItemTransferredProperty, RecordEditItemTransferredProperty } from "./recordEditItemTransferredProperty";
import { IRecordEditItemFamiliarization, RecordEditItemFamiliarization } from "./recordEditItemFamiliarization";
import { IRecordEditItemQualification, RecordEditItemQualification } from "./recordEditItemQualification";

export interface IRecordEditItem extends IEditItem {
    basicEducationId: string;
    unitId: string;
    unitCode: string;
    userId: string;
    userCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    birthDate: number;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    employeeType: RecordEmployeeType;
    ibanNumber: string;
    bicCode: string;
    taxNumber: string;
    driversLicenseType: string;
    workShiftName: string;
    comment: string;
    activeState: number;
    personalIdentityCode: string;
    identifier: string;
    nextOfKinFirstName: string;
    nextOfKinLastName: string;
    nextOfKinPostalAddress: string;
    nextOfKinPostalCode: string;
    nextOfKinCity: string;
    nextOfKinPhone: string;
    nextOfKinEmail: string;
    modifyUser: IModifyUser;
    familiarizations: IRecordEditItemFamiliarization[];
    employments: IRecordEditItemEmployment[];
    furtherEducations: IRecordEditItemFurtherEducation[];
    transferredProperties: IRecordEditItemTransferredProperty[];
    qualifications: IRecordEditItemQualification[];
    sheetDataRows: ITaskDataRow[];

    getName(): string;
    initializeSheetDataRowsRows(taskType: ITaskEditTypeItem);
}

export class RecordEditItem extends EditItem implements IRecordEditItem {
    basicEducationId: string;
    unitId: string;
    unitCode: string;
    userId: string;
    userCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    birthDate: number;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    employeeType: RecordEmployeeType;
    ibanNumber: string;
    bicCode: string;
    taxNumber: string;
    driversLicenseType: string;
    workShiftName: string;
    comment: string;
    activeState: number;
    personalIdentityCode: string;
    identifier: string;
    nextOfKinFirstName: string;
    nextOfKinLastName: string;
    nextOfKinPostalAddress: string;
    nextOfKinPostalCode: string;
    nextOfKinCity: string;
    nextOfKinPhone: string;
    nextOfKinEmail: string;
    modifyUser: ModifyUser;
    familiarizations: RecordEditItemFamiliarization[];
    employments: RecordEditItemEmployment[];
    furtherEducations: RecordEditItemFurtherEducation[];
    transferredProperties: RecordEditItemTransferredProperty[];
    qualifications: RecordEditItemQualification[];
    sheetDataRows: TaskDataRow[];

    constructor();
    constructor(obj: IRecordEditItem);
    constructor(obj?: any) {
        super(obj);
        this.basicEducationId = obj && obj.basicEducationId || "";
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.userId = obj && obj.userId || "";
        this.userCode = obj && obj.userCode || "";
        this.firstName = obj && obj.firstName || "";
        this.middleName = obj && obj.middleName || "";
        this.lastName = obj && obj.lastName || "";
        this.picture = obj && obj.picture || "";
        this.birthDate = obj && obj.birthDate || null;
        this.postalAddress = obj && obj.postalAddress || "";
        this.postalCode = obj && obj.postalCode || "";
        this.city = obj && obj.city || "";
        this.phone = obj && obj.phone || "";
        this.email = obj && obj.email || "";
        this.employeeType = obj && obj.employeeType || RecordEmployeeType.Employee;
        this.ibanNumber = obj && obj.ibanNumber || "";
        this.bicCode = obj && obj.bicCode || "";
        this.taxNumber = obj && obj.taxNumber || "";
        this.driversLicenseType = obj && obj.driversLicenseType || "";
        this.workShiftName = obj && obj.workShiftName || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.personalIdentityCode = obj && obj.personalIdentityCode || "";
        this.identifier = obj && obj.identifier || "";
        this.nextOfKinFirstName = obj && obj.nextOfKinFirstName || "";
        this.nextOfKinLastName = obj && obj.nextOfKinLastName || "";
        this.nextOfKinPostalAddress = obj && obj.nextOfKinPostalAddress || "";
        this.nextOfKinPostalCode = obj && obj.nextOfKinPostalCode || "";
        this.nextOfKinCity = obj && obj.nextOfKinCity || "";
        this.nextOfKinPhone = obj && obj.nextOfKinPhone || "";
        this.nextOfKinEmail = obj && obj.nextOfKinEmail || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.familiarizations = Base.getTypedArray(obj ? obj.familiarizations : null, RecordEditItemFamiliarization);
        this.employments = Base.getTypedArray(obj ? obj.employments : null, RecordEditItemEmployment);
        this.furtherEducations = Base.getTypedArray(obj ? obj.furtherEducations : null, RecordEditItemFurtherEducation);
        this.transferredProperties = Base.getTypedArray(obj ? obj.transferredProperties : null, RecordEditItemTransferredProperty);
        this.qualifications = Base.getTypedArray(obj ? obj.qualifications : null, RecordEditItemQualification);
        this.sheetDataRows = Base.getTypedArray(obj ? obj.sheetDataRows : null, TaskDataRow);
    }

    getName(): string {
        return ((this.firstName ?? "") + " " + (this.lastName ?? "")).trim();
    }

    initializeSheetDataRowsRows(taskType: ITaskEditTypeItem) {
        for (let i = 0; i < this.sheetDataRows.length; i++) {
            this.sheetDataRows[i].initializeCols(taskType);
        }
    }
}